<template>
  <div class="renlian-index">
    <!-- 加载中：不渲染任何子组件，避免闪烁 -->
    <template v-if="!loading">
      <!-- 人脸识别页面 -->
      <RenlianDenglu v-if="isFaceRecognitionEnabled" />
      <!-- 选择基本信息页面 -->
      <Xuanzejibenxinxi v-else />
    </template>
  </div>
</template>

<script>
import apiOpen from '@/api/open.js'
import RenlianDenglu from './renliandenglu.vue'
import Xuanzejibenxinxi from '../xuanzejibenxinxi/index.vue'

export default {
  name: 'RenlianIndex',
  components: {
    RenlianDenglu,
    Xuanzejibenxinxi
  },
  data () {
    return {
      robotCode: window.robotCode,
      loading: true,
      isFaceRecognitionEnabled: false
    }
  },
  created () {
    this.GetRobots()
  },
  methods: {
    // 获取机器人权限
    GetRobots () {
      apiOpen
        .RobotsList()
        .then(res => {
          this.isFaceRecognitionEnabled = res.isFaceRecognitionEnabled
          this.loading = false
          console.log("获取机器人isFaceRecognitionEnabled", this.isFaceRecognitionEnabled)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
  },
}
</script>

<style scoped lang="less">
.renlian-index {
  width: 100%;
  height: 100%;
}
</style>
